import { render, staticRenderFns } from "./companyProfile.vue?vue&type=template&id=197b5552&scoped=true"
import script from "./companyProfile.vue?vue&type=script&lang=js"
export * from "./companyProfile.vue?vue&type=script&lang=js"
import style0 from "./companyProfile.vue?vue&type=style&index=0&id=197b5552&prod&lang=less&scoped=true"
import style1 from "./companyProfile.vue?vue&type=style&index=1&id=197b5552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b5552",
  null
  
)

export default component.exports